// Currency utility functions

const currencySymbols: Record<string, string> = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  CHF: 'Fr',
  CAD: 'CA$',
  AUD: 'A$',
  CNY: '¥',
  INR: '₹',
  BRL: 'R$',
  ZAR: 'R',
  RUB: '₽',
  KRW: '₩',
  MXN: 'MX$',
  SEK: 'kr',
  NOK: 'kr',
  DKK: 'kr',
  PLN: 'zł',
  THB: '฿',
  IDR: 'Rp',
  HUF: 'Ft',
  CZK: 'Kč',
  ILS: '₪',
  PHP: '₱',
  AED: 'د.إ',
  COP: 'COL$',
  SAR: 'ر.س',
  MYR: 'RM',
  RON: 'lei',
};

export function getCurrencySymbol(currencyCode: string): string {
  return currencySymbols[currencyCode.toUpperCase()] || currencyCode;
}

export function formatCurrency(amount: number, currencyCode: string = 'USD', showCurrencyCode: boolean = false): string {
  const symbol = getCurrencySymbol(currencyCode);
  
  // For currencies that typically go after the amount
  const suffixCurrencies = ['SEK', 'NOK', 'DKK', 'CZK', 'PLN', 'HUF', 'RON'];
  
  const formattedAmount = amount.toFixed(2);
  const code = showCurrencyCode ? ` ${currencyCode}` : '';
  
  if (suffixCurrencies.includes(currencyCode.toUpperCase())) {
    return `${formattedAmount} ${symbol}${code}`;
  }
  
  return `${symbol}${formattedAmount}${code}`;
}
